<template>
<div class="chapter">
<div class="inner_page">
<p class="title-1"><span class="small">RECOLLECTIONS</span></p>
<p class="subtitle-1"><b><i>of Early Texas</i></b><a id="page_2"></a></p>
<p class="image-1" id="a2"><img alt="image" src="html/images/map1.jpg"/></p>
<p class="fcap">R<span class="small">EPUBLIC OF</span> T<span class="small">EXAS.</span> <i>From Stanley Siegel,</i> A Political History of the Texas Republic, 1836–1845, <i>1956</i><a id="page_3"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780292749375_12_htit1.vue?8d73d020